export default {
  SuTransferList: {
    TitleList: 'Điều chuyển CCDC',
  },
  SuTransferDetail: {
    Title: 'Điều chuyển CCDC',
    Text: {
      OtherInfo: 'Thông tin khác',
      GeneralInfo: 'Thông tin chung',
      RefDate: 'Ngày CT',
      PostedDate: 'Ngày HT',
      RefNo: 'Số CT',
      Description: 'Diễn giải',
      CTReference: 'CT tham chiếu',
    },
    TextTooltip: {
      RefDate: 'Ngày chứng từ',
      RefNo: 'Số chứng từ',
      PostedDate: 'Ngày hạch toán',
    },
    PopupCheckDebitAccount: {
      Content: 'Thông tin tài khoản ghi tăng không hợp lệ. Xin vui lòng kiểm tra lại.',
      Title: 'Cất không thành công',
    },
    PopupCheckCreditAccount: {
      Content: 'Thông tin tài khoản ghi giảm không hợp lệ. Xin vui lòng kiểm tra lại.',
      Title: 'Cất không thành công',
    },
    PopupCheckAmount: {
      Content: 'Số ký tự cột thành tiền vượt quá số lượng quy định (14 ký tự). Vui lòng kiểm tra lại.',
      Title: 'Không hợp lệ',
    },
  },
};
